import { render, staticRenderFns } from "./AreaMangeDetail.vue?vue&type=template&id=8b637860&scoped=true"
import script from "./AreaMangeDetail.vue?vue&type=script&lang=js"
export * from "./AreaMangeDetail.vue?vue&type=script&lang=js"
import style0 from "./AreaMangeDetail.vue?vue&type=style&index=0&id=8b637860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b637860",
  null
  
)

export default component.exports